import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/score/AInvite/index",{params:{
            ...params
        }

    } )
}
function GET_LIST_DETAILS(params) {
    return axios.get("/score/ACustomerScore/scoreRecordList",{params:{
            ...params
        }

    } )
}

function EXPORT(params) {
    return  axios.get("/score/AInvite/export",{
        params: {
            ...params
        }
    }  )
}

function GET_LIST_RECORD(params) {
    return axios.get("/score/MScoreExchange/index",{params:{
            ...params
        }

    } )
}

function AUDIT(params) {
    return axios.post("/score/AInvite/audit",
        {...params}
    )
}


export default {
    GET_LIST,
    EXPORT,
    GET_LIST_DETAILS,
    GET_LIST_RECORD,
    AUDIT
};
